export enum ProgressMeterType {
	PageNumber = 1,
	PagePercentage = 2,
}
